import {
    CartModel,
    HttpConfig,
    JourneyModel,
    JourneyType,
    ProductModel,
    ProductType,
    VirtualCartRepository,
} from '@bytel/leviator';

import { getAppConfig } from '@services/config';

const oneConfig = getAppConfig().defaultPlans.one;

// Temporaire : maintient le lien du pack One en attendant que les APIs exposent la dépendance FAI/mobile à Leviator dans l'auto-add.
export class OneCartRepository<Config extends HttpConfig> extends VirtualCartRepository<Config> {
    protected override getProductsToRemove(cart: CartModel, deletedProduct: ProductModel | undefined) {
        const productsToRemove = super.getProductsToRemove(cart, deletedProduct);
        if (!deletedProduct || !oneConfig.planGencode) return productsToRemove;

        const isOneFai = (product: ProductModel) =>
            product.isType(ProductType.MAIN_FAI_OFFER) &&
            product.metadata?.rangeNg === oneConfig.rangeNg &&
            product.metadata?.commercialSeries === oneConfig.commercialSeries;

        let counterpart: ProductModel | undefined;
        if (isOneFai(deletedProduct)) {
            counterpart = cart
                .getJourneyOfType(JourneyType.MOBILE_ACQUISITION)
                ?.getProductsByType(ProductType.MAIN_MOBILE_OFFER)
                .find((product) => product.gencode === oneConfig.planGencode);
        } else if (
            deletedProduct.isType(ProductType.MAIN_MOBILE_OFFER) &&
            deletedProduct.gencode === oneConfig.planGencode
        ) {
            counterpart = cart
                .getJourneyOfType(JourneyType.FAI_ACQUISITION)
                ?.getProductsByType(ProductType.MAIN_FAI_OFFER)
                .find(isOneFai);
        }

        if (counterpart) {
            const linkedRemovals: Map<JourneyModel, ProductModel[]> = super.getProductsToRemove(cart, counterpart);
            for (const [journey, products] of linkedRemovals) {
                productsToRemove.set(journey, [...new Set([...(productsToRemove.get(journey) ?? []), ...products])]);
            }
        }
        return productsToRemove;
    }
}
